import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { teachurKeys } from '@teachur/http-client';
import type { Message } from '@teachur/http-client';
import { getSocketInstance, createSocketInstance } from '@services/socketService';

export const useChatSocket = (selectedChatId?: number) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    let socket = getSocketInstance();
    if (!socket) {
      socket = createSocketInstance();
    }

    if (!socket) {
      return;
    }

    if (!socket.connected) {
      socket.connect();
    }

    const onNewChatMessage = (data: { chatId: number; message: Message }) => {
      queryClient.refetchQueries({ queryKey: teachurKeys.chat.list() });

      if (selectedChatId && data.chatId === selectedChatId) {
        queryClient.refetchQueries({ queryKey: teachurKeys.chat.detail(selectedChatId) });
      }
    };

    const setupSocketListeners = () => {
      if (selectedChatId) {
        socket?.emit('joinChatRoom', selectedChatId);
      }

      socket?.on('newChatMessage', onNewChatMessage);
    };

    if (socket.connected) {
      setupSocketListeners();
    } else {
      socket.once('connect', setupSocketListeners);
    }

    return () => {
      socket?.off('connect', setupSocketListeners);
      socket?.off('newChatMessage', onNewChatMessage);

      if (selectedChatId) {
        socket?.emit('leaveChatRoom', selectedChatId);
      }
    };
  }, [queryClient, selectedChatId]);
};
